import type { AnyRoute } from "@tanstack/react-router";

import { rootRoute } from "./root-route";
import { routes as g1a } from "./g1a";
import { routes as g1b } from "./g1b";
import { routes as g1c } from "./g1c";
import { routes as g2a } from "./g2a";
import { routes as g2b } from "./g2b";
import { routes as g2c } from "./g2c";
import { routes as g3a } from "./g3a";
import { routes as g3b } from "./g3b";
import { routes as g4a } from "./g4a";
import { routes as g4b } from "./g4b";
import { routes as g4c } from "./g4c";
import { routes as g5a } from "./g5a";
import { routes as w0b } from "./w0b";

// 배치 순서 — 슬롯 파일은 배치마다 따로라 병렬 배치가 이 파일을 고치지 않는다(D1).
export const SLOTS: Record<string, AnyRoute[]> = { w0b, g1a, g1b, g1c, g2a, g2b, g2c, g3a, g3b, g4a, g4b, g4c, g5a };

interface SlotOptions {
  id?: string;
  path?: string;
  getParentRoute?: () => AnyRoute;
}

const optionsOf = (route: AnyRoute): SlotOptions => route.options as SlotOptions;

// 슬롯의 route 를 부모별로 모아 addChildren 한다 — 부모가 루트도 슬롯 route 도 아니면 빠뜨리지 않고 멈춘다.
export const assembleTree = (root: AnyRoute, routes: AnyRoute[]): AnyRoute => {
  const known = new Set<AnyRoute>([root, ...routes]);
  const children = new Map<AnyRoute, AnyRoute[]>();
  for (const route of routes) {
    const options = optionsOf(route);
    const parent = options.getParentRoute?.();
    if (!parent || !known.has(parent)) throw new Error(`라우트 ${options.id ?? options.path ?? "?"} 의 부모가 트리에 없습니다`);
    children.set(parent, [...(children.get(parent) ?? []), route]);
  }
  const attach = (route: AnyRoute): AnyRoute => {
    const kids = children.get(route);
    return kids ? route.addChildren(kids.map(attach)) : route;
  };
  return attach(root);
};

export const routeTree = assembleTree(rootRoute, Object.values(SLOTS).flat());
